import App from "@/App.vue";
import router from "@/router";
import { registerPlugins } from "@core/utils/plugins";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { createApp } from "vue";
import "./utils/axios";

// Styles
import "@core-scss/template/index.scss";
import "@styles/styles.scss";

import "@styles/responsive.scss";

// The VitePWA plugin automatically generates this virtual module
import { registerSW } from 'virtual:pwa-register';

// Register the service worker
registerSW({
  immediate: true,
  onNeedRefresh() {},
})
// Create vue app
const app = createApp(App);

// Use router
app.use(router);

app.component('VueDatePicker', VueDatePicker);

// Register plugins
registerPlugins(app);

// Mount vue app
app.mount("#app");
